import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cambioPassword, enviarCodigoPassword, reenviarCodigoLogin, verificarCodigoLogin, verificarCodigoPassword } from "../../api/login";
import { FaCheck, FaEnvelope, FaShieldAlt, FaKey } from "react-icons/fa";
import { alertaGeneral } from "../../utils/alertas";
import { validarInputExpresionRegular } from "../../utils/generalFunctions";
import { useDataUser } from "../../context/dataUserContext";
import logoSalutioRed from "../../images/salutioRed.png";
import backgroundImage from '../../images/background2.png';

export default function LoginVerificacion() {
    const location = useLocation();
    const email = location.state?.email;
    const render = location.state?.render;
    const navigate = useNavigate();
    const { setIsAuth } = useDataUser();

    useEffect(() => {
        if (!email || !render) {
            // Si no hay email o render, redirigir a la página de inicio
            navigate('/');
        }
    }, [])
    const [someInputChange, setSomeInputChange] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [isCodePasswordValid, setIsCodePasswordValid] = useState(false);
    const [codigo, setCodigo] = useState('');
    const inputRefs = useRef([]);

    useEffect(() => {

        if (inputRefs.current.some((input) => input.value === '')) {
            setIsComplete(false);
            return;
        }

        const codigo = inputRefs.current.reduce((acc, input) => acc + input.value, '');
        console.log(codigo);
        setCodigo(codigo);
        setIsComplete(true);

    }, [someInputChange]);

    const onClickValidarCodigo = async (ev) => {
        ev.preventDefault();
        if (render === "login") {
            //Llamar a la API para verificar el codigo
            const response = await verificarCodigoLogin(codigo, email);

            if (response.ok === false) {
                alertaGeneral({ titulo: response.error, isError: true });
                return;
            }

            // Configuración de Local Storage (clinicId desde response.clinicId; si no existe, no guardar para que paciente use endpoint público)
            localStorage.setItem('token', response.token);
            localStorage.setItem('role', response.role);
            const clinicIdToStore = response.clinicId ?? response.userId;
            if (clinicIdToStore != null && String(clinicIdToStore) !== 'null' && String(clinicIdToStore) !== 'undefined') {
                localStorage.setItem('clinicId', clinicIdToStore);
            } else {
                localStorage.removeItem('clinicId');
            }
            response.imageProfile && localStorage.setItem('imageProfile', response.imageProfile);
            const setIfValid = (key, value) => {
                if (value != null && String(value).trim() !== '' && String(value) !== 'null' && String(value) !== 'undefined') {
                    localStorage.setItem(key, value);
                } else {
                    localStorage.removeItem(key);
                }
            };
            setIfValid('clinicName', response.clinicName);
            setIfValid('clinicEmail', response.clinicEmail);
            setIfValid('patientName', response.patientName);
            setIfValid('patientEmail', response.patientEmail);
            setIfValid('patientId', response.patientId);
            setIfValid('doctorName', response.doctorName);
            setIfValid('doctorEmail', response.doctorEmail);
            setIfValid('doctorId', response.doctorId);
            setIfValid('adminName', response.adminName);
            setIfValid('adminEmail', response.adminEmail);
            setIfValid('adminId', response.adminId);
            setIsAuth(true);

            switch (response.role) {
                case 'admin':
                    navigate('/admin');
                    break;
                case 'clinicAdmin':
                    navigate('/clinic');
                    break;
                case 'clinic':
                    navigate('/clinic');
                    break;
                case 'doctor':
                    // Si debe pagar la membresía (p. ej. se registró con Google en /registro-pagado y no ha pagado), ir a registro-pagado
                    if (response.requiresMembershipPayment) {
                        navigate('/registro-pagado', {
                            state: {
                                needsPayment: true,
                                fromLogin: true,
                                doctorName: response.doctorName || '',
                                email: response.doctorEmail || ''
                            }
                        });
                    } else if (response.doctorEstado === 'no_aprobado' || response.doctorEstado === 'en_revision') {
                        navigate('/doctor/perfil');
                    } else {
                        navigate('/doctor/dashboard');
                    }
                    break;
                case 'patient':
                    // Si el paciente es nuevo (perfil incompleto o aún no ha agendado ninguna cita), ir al directorio de profesionales
                    const profileIncomplete = response.patientProfileComplete === false || response.patientProfileComplete === null || response.patientProfileComplete === undefined;
                    const sinCitasAgendadas = response.patientHasAppointments === false || response.patientHasAppointments === undefined;
                    if (profileIncomplete || sinCitasAgendadas) {
                        navigate('/patient/directorio-profesionales');
                    } else {
                        navigate('/patient/dashboard');
                    }
                    break;
                default:
                    break;
            }
        } else if (render === "password") {
            //Llamar a la API para verificar el codigo
            const response = await verificarCodigoPassword(codigo, email);

            if (response.ok === false) {
                alertaGeneral({ titulo: response.error, isError: true });
                return;
            }

            setIsCodePasswordValid(true);
        }
    }

    const onClickReenviarCodigo = async () => {
        if (render === "login") {
            const response = await reenviarCodigoLogin(email);
            console.log(response.ok === false)
            if (response.ok === false) {
                alertaGeneral({ titulo: 'Error', messageHtml: response.error, isError: true });
                return;
            }
            alertaGeneral({ titulo: 'Exito', messageHtml: response.message });
        }

        if (render === "password") {
            const response = await enviarCodigoPassword(email);
            if (response.ok === false) {
                alertaGeneral({ titulo: 'Error', messageHtml: response.error, isError: true });
                return;
            }
            alertaGeneral({ titulo: 'Exito', messageHtml: response.message });
        }
    }

    const handleChange = (e, index) => {
        e.target.select();
        const value = e.target.value;
        //Cuando se esta escribiendo o se usa la flecha derecha, pasa al siguiente
        if (value.length >= 1 && index < inputRefs.current.length - 1 || e.key === 'ArrowRight' && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1].focus();
        }

        //Cuando se borra o se pulsa la flecha izquierda, pasa al anterior
        if (e.key === 'Backspace' && index > 0 || e.key === 'ArrowLeft' && index > 0) {
            inputRefs.current[index - 1].focus();
        }
        setSomeInputChange(!someInputChange);
    };

    const handleInput = (e) => {
        e.target.value = validarInputExpresionRegular(e, /[^0-9]/g);
    }

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [isPasswordResetOk, setIsPasswordResetOk] = useState(false);

    const validatePassword = (password) => {
        const minLength = 6;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasNumber = /\d/.test(password);
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (password.length < minLength) {
            return `La contraseña debe tener al menos ${minLength} caracteres.`;
        }
        if (!hasUpperCase) {
            return 'La contraseña debe tener al menos una letra mayúscula.';
        }
        if (!hasNumber) {
            return 'La contraseña debe tener al menos un número.';
        }
        if (!hasSymbol) {
            return 'La contraseña debe tener al menos un símbolo.';
        }
        return null;
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        const error = validatePassword(value);
        if (error) {
            setError(error);
        } else if (confirmPassword && value !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
        } else {
            setError(null);
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        if (password && value !== password) {
            setError('Las contraseñas no coinciden.');
            setIsPasswordResetOk(false);
        } else {
            setError(null);
        }
    }

    const onHandleCambiarPassword = async () => {
        const response = await cambioPassword(email, password, codigo);
        if (response.ok === false) {
            alertaGeneral({ titulo: 'Error', messageHtml: response.error, isError: true });
            return;
        }
        alertaGeneral({ titulo: 'Exito', messageHtml: 'Contraseña actualizada correctamente' });
        navigate('/');
    }

    useEffect(() => {
        if (password && confirmPassword && !error) {
            setIsPasswordResetOk(true);
        } else {
            setIsPasswordResetOk(false);
        }
    }, [error])

    return (
        <div className="min-h-screen relative flex items-center justify-center px-4 py-6">
            {/* Fondo con imagen y capa de desenfoque */}
            <div 
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${backgroundImage})` }}
                aria-hidden
            />
            <div 
                className="absolute inset-0 bg-white/20 backdrop-blur-md"
                aria-hidden
            />
            {/* Modal más compacto sobre fondo desenfocado */}
            <div className="relative z-10 w-full max-w-[340px] bg-white/95 backdrop-blur-sm p-4 md:p-6 rounded-2xl shadow-2xl animate-fade-in border border-gray-200/50">
                <div className="flex justify-center mb-4 md:mb-6 animate-slide-up">
                    <img 
                        src={logoSalutioRed} 
                        alt="Logo Redplika" 
                        className="max-w-[10em] md:max-w-[12em] cursor-pointer transition-transform duration-300 hover:scale-105" 
                        onClick={() => navigate('/')}
                    />
                </div>
                
                <div className="text-center mb-5 md:mb-6 animate-slide-up" style={{ animationDelay: '0.1s' }}>
                    <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#1f94c2ff] rounded-full mb-4 shadow-lg">
                        <FaShieldAlt className="text-white text-2xl md:text-3xl" />
                    </div>
                    <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">Verifica tu código</h2>
                    <p className="text-xs md:text-sm text-gray-600 mb-2">Hemos enviado un código de 4 dígitos a:</p>
                    <p className="text-sm md:text-base font-semibold text-[#1f94c2ff] break-all px-2">{email}</p>
                </div>
                <form onSubmit={onClickValidarCodigo} className="mb-5 md:mb-6">
                    <div className="flex justify-center gap-2 md:gap-3 mb-4 md:mb-6 animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        {[0, 1, 2, 3].map((i) => (
                            <input 
                                key={i} 
                                type="text" 
                                maxLength="1" 
                                disabled={isCodePasswordValid}
                                className="w-14 h-14 md:w-16 md:h-16 text-2xl md:text-3xl font-bold text-center border-2 border-gray-300 rounded-xl md:rounded-2xl focus:outline-none focus:ring-2 md:focus:ring-4 focus:ring-[#1f94c2ff] focus:ring-opacity-30 focus:border-[#1f94c2ff] transition-all duration-300 hover:border-[#1f94c2ff] hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed bg-white"
                                ref={(el) => (inputRefs.current[i] = el)}
                                onInput={handleInput}
                                onKeyUp={(e) => handleChange(e, i)}
                            />
                        ))}
                    </div>
                    {isComplete && (
                        <div className="flex justify-center animate-slide-up" style={{ animationDelay: '0.3s' }}>
                            <button 
                                className="w-full flex items-center justify-center gap-2 bg-[#1f94c2ff] hover:bg-[#1a7fa8] text-white font-semibold text-base md:text-lg px-4 py-3 md:py-4 rounded-lg md:rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                                type="submit"
                                disabled={isCodePasswordValid}
                            >
                                <FaCheck className="text-lg md:text-xl" />
                                Verificar Código
                            </button>
                        </div>
                    )}
                </form>

                {isCodePasswordValid && (
                    <div className="animate-slide-up space-y-3 md:space-y-4">
                        <div>
                            <label htmlFor="password" className="block text-xs md:text-sm font-semibold text-gray-700 mb-1.5">
                                Nueva Contraseña
                            </label>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                value={password}
                                required
                                onChange={handlePasswordChange}
                                placeholder="Ingresa tu nueva contraseña"
                                className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-300 rounded-lg md:rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1f94c2ff] focus:border-[#1f94c2ff] transition duration-200 shadow-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="confirm-password" className="block text-xs md:text-sm font-semibold text-gray-700 mb-1.5">
                                Confirma Nueva Contraseña
                            </label>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="confirm-password"
                                name="confirm-password"
                                value={confirmPassword}
                                required
                                onChange={handleConfirmPasswordChange}
                                placeholder="Confirma tu nueva contraseña"
                                className="w-full px-3 md:px-4 py-2.5 md:py-3 text-sm md:text-base border-2 border-gray-300 rounded-lg md:rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1f94c2ff] focus:border-[#1f94c2ff] transition duration-200 shadow-sm"
                            />
                        </div>
                        <p 
                            className="text-xs md:text-sm text-[#1f94c2ff] font-medium cursor-pointer w-fit hover:underline transition-colors" 
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? '👁️ Ocultar' : '👁️‍🗨️ Mostrar'} contraseña
                        </p>
                        {error && (
                            <p className="text-xs md:text-sm text-red-500 font-medium animate-fade-in"> {error} </p>
                        )}
                        <button 
                            disabled={!isPasswordResetOk} 
                            className="w-full py-2.5 md:py-3 text-sm md:text-base font-semibold bg-[#1f94c2ff] hover:bg-[#1a7fa8] text-white rounded-lg md:rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-md disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                            onClick={onHandleCambiarPassword}
                        >
                            Cambiar Contraseña
                        </button>
                    </div>
                )}

                {!isCodePasswordValid && (
                    <div className="animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        <p className="text-xs md:text-sm text-center text-gray-500 mb-4 md:mb-6 px-2">
                            ¿No recibiste el código? Puedes reenviarlo o regresar al inicio de sesión.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
                            <button
                                onClick={onClickReenviarCodigo}
                                className="flex-1 py-2.5 md:py-3 text-sm md:text-base font-semibold bg-white text-[#1f94c2ff] border-2 border-[#1f94c2ff] hover:bg-[#e6f6fc] rounded-lg md:rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-sm"
                            >
                                Reenviar Código
                            </button>
                            <button 
                                className="flex-1 py-2.5 md:py-3 text-sm md:text-base font-semibold bg-gray-100 text-gray-700 border-2 border-gray-300 hover:bg-gray-200 rounded-lg md:rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-sm" 
                                onClick={() => navigate('/login')}
                            >
                                Regresar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>

    )
}